
































import Vue from 'vue'
import UiIcon from '@/components/UiIcon.vue'

export default Vue.extend({
  name: "AppFooter",
  props: {
    organization: {} // as OrganizationInterface
  },
  methods: {
    currentPage(){ return location.href },
    currentUserName(){ return this.$store.getters.userName },
    currentUserEmail(){ return this.$store.getters.userEmail },
    currentUserAgent(){ return navigator.userAgent },
    currentTimeStamp(){ return new Date() },
    currentErrorLogs(){
      return JSON.stringify(console.errors?.map((e, i) => e.map((ee, ii) => `${i}.${ii} :: ${ee.message} :: ${ee.stack}`)))
    },
    isAdmin(){ return this.$store.getters.userIsAdmin }
  },
  components: {
    UiIcon
  },
})
